import React from 'react'

const SvgHairDryerFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 3.804a1 1 0 00-1.53-.848l-1.954 1.222c-.448-.116-.9-.235-1.352-.355C13.768 2.927 10.254 2 7 2a5 5 0 00-.918 9.916l1.97 8.534a2 2 0 003.897-.9l-1.8-7.797c2.313-.335 4.692-.963 7.015-1.576.453-.12.904-.239 1.351-.355l1.955 1.222a1 1 0 001.53-.848V3.804zM7 9a2 2 0 100-4 2 2 0 000 4z'
    />
  </svg>
)

export default SvgHairDryerFilled
